import BackCard from "../BackCard";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { socket } from "../../socket";
import { cardPicked } from "../../features/game/gameSlice";
import { motion } from "motion/react";

import styles from "./DrawPile.module.css";

function DrawPile() {
  const drawPile = useAppSelector((state) => state.game.game.drawPile);
  const pickACard = useAppSelector((state) => state.game.pickACard);
  const roomId = useAppSelector((state) => state.user.roomId);

  const dispatch = useAppDispatch();

  function handleOnClick() {
    if (pickACard) {
      dispatch(cardPicked());
      socket.emit("no card to play", roomId);
    }
  }

  return (
    <div className={styles.drawPile} onClick={handleOnClick}>
      {drawPile.map((card, index) => {
        return (
          <motion.div layoutId={card.id} key={card.id}>
            {index === drawPile.length - 1 ? (
              <BackCard pickACard={pickACard} />
            ) : (
              <BackCard />
            )}
          </motion.div>
        );
      })}
    </div>
  );
}

export default DrawPile;
